import { Pipe, PipeTransform } from '@angular/core';
import { isDate, isPast, isValid } from 'date-fns';

@Pipe({
  name: 'inThePast',
})
export class InThePastPipe implements PipeTransform {
  public transform(value: string | number | Date): boolean {
    if (!isDate(value)) {
      value = new Date(value);
    }

    if (!isValid(value)) {
      return false;
    }

    return isPast(value as Date);
  }
}
